// Zoom scale / speed of the scroll wheel zooming functionality.
export const SCROLL_ZOOM_SCALE = 1.05;
// Zoom scale / speed of the plus / minus buttons / keybinds.
export const BUTTON_ZOOM_SCALE = 1.3;

// The max allowed value to zoom in. This is fairly arbitrary just to prevent some insane value.
export const MAX_ZOOM_IN = 100;
// The max allowed zoom OUT value. THIS IS VERY IMPORTANT. As items on the canvas get smaller
// drawing certain shapes causes errors since certain mathematical functions cannot be run on zero
// values (after rounding).
export const MAX_ZOOM_OUT = 0.1;

// The spacing between the edge of the stage and the image rendered when in constrain mode.
export const STAGE_SIDE_PADDING = 16;

export enum DiffUiDisplayType {
  SideBySide,
  Single,
}
